import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
} from "@angular/core";
import { pinwheel, ring, tailChase } from "ldrs";
import { Nillable } from "../../types/nillable";

pinwheel.register();
ring.register();
tailChase.register();

export type CsLoaderVariant = "pinwheel" | "ring" | "tailChase";

@Component({
  selector: "cs-loader",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./cs-loader.component.html",
  styleUrls: ["./cs-loader.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CsLoaderComponent {
  @Input() variant: CsLoaderVariant = "pinwheel";
  @Input() size: number | string = 20;
  @Input() color = "currentColor";
  @Input() stroke: number | string = 2.5;
  @Input() speed: number | string = 2;
  @Input() label = "";
  @Input() progress: Nillable<number> = null;

  get hasProgress(): boolean {
    return this.progress !== null;
  }

  get progressValue(): number {
    return Number.isFinite(this.progress) ? this.progress : 0;
  }
}
